module.exports = __webpack_public_path__ + "static/media/playIconBlackWithBg.7f0c3332.png";